import apiClient from './api';

export interface RewardCardDto {
  id: number;
  flowType: 'direct_scratch' | 'milestone_stamp' | 'milestone_spend';
  state: 'locked' | 'scratched' | 'redeemed' | 'expired';
  rewardLabel?: string;
  rewardType?: string;
  rewardValue?: string;
  redemptionCode?: string | null;
  validFrom?: string;
  validUntil?: string;
  orderId?: number;
  orderCode?: string;
  scratchedAt?: number | null;
  redeemedAt?: number | null;
}

export interface StampProgress {
  current: number;
  total: number;
}

export interface SpendProgress {
  current: number;
  total: number;
}

export interface WalletResponse {
  cards: RewardCardDto[];
  stampProgress?: StampProgress;
  spendProgress?: SpendProgress;
  restaurantName?: string;
  restaurantLogoUrl?: string;
}

export interface ScratchResult {
  cardId: number;
  rewardLabel: string;
  rewardType: string;
  rewardValue: string;
  redemptionCode: string;
  validUntil?: string;
}

export interface RewardsConfig {
  enabled: boolean;
  directScratchEnabled: boolean;
  stampCardEnabled: boolean;
  stampThreshold: number;
  spendTiersEnabled: boolean;
}

const rewardsService = {
  async getWallet(appName: string): Promise<WalletResponse> {
    const response = await apiClient.get(`/api/restaurants/${appName}/rewards/wallet`);
    return response.data as WalletResponse;
  },

  async scratchCard(appName: string, cardId: number): Promise<ScratchResult> {
    const response = await apiClient.post(`/api/restaurants/${appName}/rewards/cards/${cardId}/scratch`);
    return response.data as ScratchResult;
  },

  async getConfig(appName: string): Promise<RewardsConfig> {
    const response = await apiClient.get(`/api/restaurants/${appName}/rewards/config`);
    return response.data as RewardsConfig;
  },
};

export default rewardsService;
